module.exports = __webpack_public_path__ + "static/media/11_l_Layer2_2.34_38.33.6a26c61a.png";